import React, {Fragment} from "react";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {compose} from "redux";
import ButtonSelect from "../button-select";
import ModuleMenuItemPlaceholder from "../module-menu-item-placeholder";
import ModulesPlaceholder from "../modules-placeholder";

const mapStateToProps = ({moduleConfigs}) => ({
  moduleConfigs: moduleConfigs
});

const TerritoryTools = ({t, moduleConfigs}) => {
  return (moduleConfigs.placeholders?.["territory-tools-menu"] || []).length === 0 ? null : (
    <Fragment>
      <ButtonSelect
        icon={<MenuBookIcon />}
        ariaLabel={t("components.header.actions.territoryTools.ariaLabel")}
        tooltip={t("components.header.actions.territoryTools.title")}
      >
        {(moduleConfigs.placeholders?.["territory-tools-menu"] || []).map(({id, component, fallback}, idx) => (
          <ModuleMenuItemPlaceholder
            key={`module-${idx}`}
            isModulePlaceholder
            id={id}
            component={component}
            fallback={fallback}
          />
        ))}
      </ButtonSelect>
      <ModulesPlaceholder id="territory-tools-dialog" />
    </Fragment>
  );
};

export default compose(withTranslation(), connect(mapStateToProps))(TerritoryTools);
